<div fxFlex fxLayout="column" fxLayoutAlign="center" fxLayoutGap="10px">
	<div (fileDropped)="onFileDropped($event)" *ngIf="access === 2" appDragAndDrop class="drag-and-drop " fxFlex
		 fxLayout="column"
		 fxLayoutAlign="center" fxLayoutGap="10px">
		<input #fileDropRef (change)="fileBrowseHandler($event?.target?.files)" id="fileDropRef" multiple type="file"/>
		<div>
			<mat-icon>cloud_upload</mat-icon>
		</div>
		<h3>Drag and drop files here</h3>
		<h3>or</h3>
		<button [color]="'primary'" mat-raised-button>Browse for files</button>
	</div>
	<app-attachment-list *ngIf="regularAttachments?.length > 0 || podAttachments?.length > 0"
						 [podAttachments]="podAttachments" [regularAttachments]="regularAttachments" [access]="access"
						 (remove)="removeAttachment($event)">
	</app-attachment-list>
</div>
